import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { fmt } from '..';
dayjs.extend(duration);
export const add = (date, value, unit) => {
    return dayjs(date).add(value, unit).toDate();
};
export const getOverdueDaysCount = (date) => {
    const today = dayjs();
    const nextReviewDate = dayjs(date);
    if (nextReviewDate.isBefore(today, 'day')) {
        return today.diff(nextReviewDate, 'day');
    }
    return 0;
};
export const getDateDisplayText = (date) => {
    const daysOverdue = getOverdueDaysCount(date);
    if (daysOverdue > 0) {
        const dayWord = daysOverdue > 1 ? 'days' : 'day';
        return `Overdue ${daysOverdue} ${dayWord}`;
    }
    return fmt.toDate(date, { preset: 'full_date' });
};
export const getDateDisplayColor = (date) => {
    const daysOverdue = getOverdueDaysCount(date);
    const daysUntilDue = getDaysUntilDate(date);
    if (daysOverdue > 0)
        return '#e03131'; // red
    if (daysUntilDue <= 30)
        return '#fab005'; // yellow
    return 'initial';
};
export const getDaysUntilDate = (date) => {
    const today = dayjs();
    const targetDate = dayjs(date);
    if (targetDate.isAfter(today, 'day')) {
        return targetDate.diff(today, 'day');
    }
    return 0;
};
export const isSameDate = (date1, date2) => {
    if (!date1 || !date2)
        return false;
    return dayjs(date1).isSame(dayjs(date2), 'day');
};
export const isExpiredOrExpiringToday = (date) => {
    if (!date)
        return false;
    const today = dayjs();
    const targetDate = dayjs(date);
    return !targetDate.isAfter(today, 'day');
};
export const jsDateFromString = (date) => {
    return dayjs(date).toDate();
};
export const calculateTillNow = (givenDate) => {
    const now = dayjs();
    const past = dayjs(givenDate);
    const diff = now.diff(past);
    const diffDuration = dayjs.duration(diff);
    const years = diffDuration.years();
    const months = diffDuration.months();
    const days = diffDuration.days();
    const hours = diffDuration.hours();
    let result = '';
    if (years > 0) {
        result += `${years} year${years > 1 ? 's' : ''}`;
        if (months > 0) {
            result += ` ${months} month${months > 1 ? 's' : ''}`;
        }
    }
    else if (months > 0) {
        result += `${months} month${months > 1 ? 's' : ''}`;
    }
    else if (days > 0) {
        result += `${days} day${days > 1 ? 's' : ''}`;
    }
    else if (hours > 0) {
        result += `${hours} hour${hours > 1 ? 's' : ''}`;
    }
    return result || '0 hours';
};
//# sourceMappingURL=datetime.js.map